export default "__VITE_ASSET__91d4dc1a__"